import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store/types'

// диспатч с типизацией
export const useAppDispatch: () => AppDispatch = useDispatch
